module.exports = __webpack_public_path__ + "static/media/wawooh.4673147f.svg";